// Tabb function
document.addEventListener("DOMContentLoaded", function() {
    // Get all tab buttons and content divs
    const tabs = document.querySelectorAll('.flyout-tabs .topline');
    const contents = document.querySelectorAll('.flyout-content');
  
    // Function to remove active class from all tabs and contents
    function removeActiveClasses() {
      tabs.forEach(tab => tab.classList.remove('active'));
      contents.forEach(content => content.classList.remove('active'));
    }
  
    // Set the first tab and content to active
    if (tabs.length > 0 && contents.length > 0) {
      tabs[0].classList.add('active');
      contents[0].classList.add('active');
    }
  
    // Add click event listener to each tab
    tabs.forEach(tab => {
      tab.addEventListener('click', function() {
        // Remove active classes
        removeActiveClasses();
  
        // Add active class to the clicked tab
        tab.classList.add('active');
  
        // Get the content id related to the clicked tab
        const contentId = tab.id.replace('tab-', 'content-');
        document.getElementById(contentId).classList.add('active');
      });
    });
});

// Open/close
jQuery(document).ready(function ($) {
  const flyout = document.querySelector('#flyout'); 
  const body = document.querySelector('body');

  $('.right-header .last-flyout').on('click', function() {
    $(flyout).addClass('active');
    $(body).addClass('active-flyout');
  });

  $('#flyout .fa-xmark').on('click', function() {
    $(flyout).removeClass('active');
    $(body).removeClass('active-flyout');
  });

  $('#flyout .topline.link').on('click', function() {
    $(flyout).removeClass('active');
    $(body).removeClass('active-flyout');
  });

  $(document).on('click', function(event) {
    if (!$(event.target).closest(flyout).length && !$(event.target).closest('.right-header .last-flyout').length) {
      $(flyout).removeClass('active');
      $(body).removeClass('active-flyout');
    }
  });


});